import {
  buildOrderLiteral,
  buildPagingLiteral,
  buildWhereLiteral,
  SortDirection,
} from '@/lib/graphql-query-builder';

export const buildGetDepartmentsLookupQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    Departments: getDepartments(
      where: ${buildWhereLiteral(where)}
      order: []
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      totalCount
      items {
        ItemId
        Title
        Key
      }
    }
  }
`;

export const buildGetDesignationsLookupQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    Designations: getDesignations(
      where: ${buildWhereLiteral(where)}
      order: []
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      totalCount
      items {
        ItemId
        Title
      }
    }
  }
`;

const EMPLOYEE_LOOKUP_FIELDS = `
  ItemId
  UserId
  DisplayName
  Email
  DepartmentId
  DepartmentName
  DepartmentKey
  DesignationId
  Designation
  ReportingManagerUserId
`;

/** Employees matching `where`; `order` sorts them on the server (e.g. by DisplayName for a paged list). */
export const buildGetEmployeesQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number,
  order: { field: string; direction: SortDirection }[] = []
) => `
  query {
    Employees: getUserProfileDetails(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral(order)}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      totalCount
      items {
        ${EMPLOYEE_LOOKUP_FIELDS}
      }
    }
  }
`;
